'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  $schema: 'http://json-schema.org/schema#',
  id: 'inboundFilters',
  type: 'object',
  properties: {
    events: { $ref: '#/definitions/events' }
  },
  additionalProperties: false,

  // References
  definitions: {
    propertyDef: {
      type: 'boolean'
    },
    eventProperties: {
      type: 'object',
      properties: {
        _: { $ref: '#/definitions/propertyDef' }
      },
      additionalProperties: {
        $ref: '#/definitions/propertyDef'
      },
      minProperties: 1
    },
    eventAction: {
      type: 'string'
    },
    eventDef: {
      anyOf: [{ type: 'boolean' }, {
        type: 'object',
        properties: {
          action: { $ref: '#/definitions/eventAction' },
          properties: { $ref: '#/definitions/eventProperties' }
        },
        minProperties: 1,
        additionalProperties: false
      }]
    },
    events: {
      type: 'object',
      properties: {
        _: { $ref: '#/definitions/eventDef' }
      },
      additionalProperties: { $ref: '#/definitions/eventDef' },
      minProperties: 1
    }
  }
};
//# sourceMappingURL=inboundFilters.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@segment/event-rules/build/inboundFilters.js
// module id = 1043
// module chunks = 0